<template>
  <vuestic-sidebar :hidden="this.isOpen"
                   :toggleWithoutAnimation="toggleWithoutAnimation">
    <template slot="menu">
      <sidebar-link
        :to="{ name: 'dashboard' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-dashboard"></span>
          <span>{{ $t('menu.dashboard') }}</span>
        </span>
      </sidebar-link>

      <sidebar-link-group>
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-files"></span>
          <span>{{ $t('menu.survey') }}</span>
        </span>
        <sidebar-link :to="{ name: 'survey-campaigns' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-calendar-check-o"></span>
            <span slot="title">{{ $t('menu.surveyCampaigns') | translate }}</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'survey-questions' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-question-circle-o"></span>
            <span slot="title">{{ $t('menu.surveyQuestions') | translate }}</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'survey-feedbacks' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-comment-o"></span>
            <span slot="title">{{ $t('menu.surveyFeedbacks') | translate }}</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>

      <sidebar-link-group>
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-settings"></span>
          <span>{{ $t('menu.settings') }}</span>
        </span>
        <sidebar-link :to="{ name: 'settings-general' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-tachometer"></span>
            <span slot="title">{{ $t('menu.settingsGeneral') | translate }}</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'settings-projects' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-folder-o"></span>
            <span slot="title">{{ $t('menu.settingsProjects') | translate }}</span>
          </span>
        </sidebar-link>
        <sidebar-link :to="{ name: 'settings-users' }">
          <span slot="title">
            <span class="sidebar-menu-item-icon fa fa-user-o"></span>
            <span slot="title">{{ $t('menu.settingsUsers') | translate }}</span>
          </span>
        </sidebar-link>
      </sidebar-link-group>

      <!--<sidebar-link
        :to="{ name: 'tables' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-tables"></span>
          <span>{{ $t('menu.tables') }}</span>
        </span>
      </sidebar-link>

      <sidebar-link-group>
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-ui-elements"></span>
          <span>{{ $t('menu.uiElements') }}</span>
        </span>
        <sidebar-link
          :to="{ name: 'typography' }">
          <span slot="title">{{ $t('menu.typography') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'buttons' }">
          <span slot="title">{{ $t('menu.buttons') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'notifications' }">
          <span slot="title">{{ $t('menu.notifications') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'icons' }">
          <span slot="title">{{ $t('menu.icons') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'spinners' }">
          <span slot="title">{{ $t('menu.spinners') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'grid' }">
          <span slot="title">{{ $t('menu.grid') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'modals' }">
          <span slot="title">{{ $t('menu.modals') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'tree-view' }">
          <span slot="title">{{ $t('menu.treeView') }}</span>
        </sidebar-link>
      </sidebar-link-group>

      <sidebar-link
        :to="{ name: 'extra' }">
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-extras"></span>
          <span>{{ $t('menu.extra') }}</span>
        </span>
      </sidebar-link>

      <sidebar-link-group>
        <span slot="title">
          <span class="sidebar-menu-item-icon vuestic-icon vuestic-icon-auth"></span>
          <span>{{ $t('menu.maps') }}</span>
        </span>
        <sidebar-link
          :to="{ name: 'google-maps' }">
          <span slot="title">{{ 'Google Maps' }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'yandex-maps' }">
          <span slot="title">{{ 'Yandex Maps' }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'leaflet-maps' }">
          <span slot="title">{{ 'Leaflet Maps' }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'bubble-maps' }">
          <span slot="title">{{ $t('Bubble Maps') }}</span>
        </sidebar-link>
        <sidebar-link
          :to="{ name: 'line-maps' }">
          <span slot="title">{{ $t('Line Maps') }}</span>
        </sidebar-link>
      </sidebar-link-group>-->
    </template>
  </vuestic-sidebar>
</template>

<script>

  import VuesticSidebar from '../../../vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar'
  import {mapGetters} from 'vuex'
  import SidebarLink from './components/SidebarLink'
  import SidebarLinkGroup from './components/SidebarLinkGroup'

  export default {
    name: 'app-sidebar',
    components: {
      VuesticSidebar,
      SidebarLink,
      SidebarLinkGroup
    },
    props: {
      isOpen: {
        type: Boolean,
        required: true
      }
    },
    computed: {
      ...mapGetters([
        'toggleWithoutAnimation'
      ]),
    }
  }


</script>



// WEBPACK FOOTER //
// src/components/admin/app-sidebar/AppSidebar.vue